module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<p> ")
    ;  if (locals.dimensions) { 
    ; __append(" ")
    ; __append(escapeFn( locals.dimensions ))
    ; __append(" <small class=\"text-muted\">(in)</small> ")
    ;  } else { 
    ; __append(" ")
    ; __append(escapeFn( locals.predefinedPackage ))
    ; __append(" ")
    ;  }
    ; __append(" <br> ")
    ; __append(escapeFn( locals.weight ))
    ; __append(" <small class=\"text-muted\">(oz)</small> </p> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/parcel_detail.ejs
// module id = 1831
// module chunks = 1